import axios from 'axios'
import type { TokenResponse, User } from '@/types/auth'
import { useAuthStore } from '@/store/authStore'

let refreshPromise: Promise<string> | null = null

export function refreshAccessToken(): Promise<string> {
  if (!refreshPromise) {
    refreshPromise = axios
      .post<TokenResponse>('/api/auth/refresh', {}, { withCredentials: true })
      .then(async ({ data }) => {
        const { data: user } = await axios.get<User>('/api/profile', {
          headers: { Authorization: `Bearer ${data.accessToken}` },
          withCredentials: true,
        })
        useAuthStore.getState().setAuth(data.accessToken, user)
        return data.accessToken
      })
      .finally(() => {
        refreshPromise = null
      })
  }

  return refreshPromise
}
